module.exports = __webpack_public_path__ + "static/media/torch-on.bb7a331f.png";